var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.07 122.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8e660d;}.cls-2{fill:#dbc03a;}.cls-3{clip-path:url(#clip-path);}.cls-4,.cls-6,.cls-7{fill:none;stroke-miterlimit:10;}.cls-4{stroke:#281b02;}.cls-4,.cls-6{stroke-width:3.64px;}.cls-5{clip-path:url(#clip-path-2);}.cls-6,.cls-7{stroke:#473203;}.cls-7{stroke-width:3.58px;}.cls-8{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(1.75)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.72 0 146.32 86.74 118.01 120.85 63.72 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(1.75)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.72 0 0 120.7 118.04 120.84 63.72 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cote"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.47 0 148.07 86.74 119.76 120.85 65.47 0"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.47,103c10-9.68,20.7-18.73,31-28.16.14-.12.3-.29.25-.47s-.42-.14-.35,0",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.07,23c2.62-2.06,5.56-4,8.21-6",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.26,36.14c4.08-4.22,9.9-6.39,14.24-10.35",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.22,49a187.37,187.37,0,0,0,16-14.22",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.44,72c5.71-5.19,13-10.06,19.32-14.55l6.43-4.61a.49.49,0,0,0-.79-.15",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.21,87c8-10.12,21.12-14.83,30.82-23.36l-.7.26",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.75,
    y1: 81.72,
    x2: 143.7,
    y2: 92.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 119.28,
    y1: 96.18,
    x2: 129.59,
    y2: 110.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 79.24,
    y1: 19.75,
    x2: 87.18,
    y2: 31.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 90.73,
    y1: 29.62,
    x2: 97.65,
    y2: 40.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 92.08,
    y1: 45.01,
    x2: 103.23,
    y2: 66.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 106.61,
    y1: 64.41,
    x2: 113.2,
    y2: 77.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 115.4,
    y1: 58.89,
    x2: 124.18,
    y2: 70.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 117.26,
    y1: 75.61,
    x2: 124.52,
    y2: 91
  }))), /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.47 0 1.75 120.7 119.79 120.84 65.47 0"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.92,23.91q12.73-.22,25.37-1.53",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.27,38.75c14.45-1.66,29.37-.49,43.51-3.48",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.15,50.59a46.1,46.1,0,0,0,5.26-.48,195.86,195.86,0,0,1,30.45-1.44c7.47.23,15,.88,22.38-.17",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.76,74.09l5.07-.38c24.9-1.8,50-1.63,74.94-2.19a.65.65,0,0,0,.51-.15c.11-.13-.09-.37-.23-.27",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.47,88.19C40.18,86.42,70,87,99.78,85.82a35.65,35.65,0,0,0,5.07-.46",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M-1.66,104.44c20.18-1.06,40.37-2.11,60.6-2,21.18.15,42.5,1.61,63.45-.92",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 48.5,
    y1: 102.29,
    x2: 48.8,
    y2: 120.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 83.99,
    y1: 103.33,
    x2: 85.38,
    y2: 122.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 63.18,
    y1: 23.77,
    x2: 63.52,
    y2: 37.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 50.85,
    y1: 38.32,
    x2: 50.85,
    y2: 48.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 76.53,
    y1: 37.15,
    x2: 78.56,
    y2: 49.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 62.57,
    y1: 48.73,
    x2: 63.52,
    y2: 72.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 32.26,
    y1: 73.77,
    x2: 30.91,
    y2: 87.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 52.2,
    y1: 72.77,
    x2: 52.2,
    y2: 86.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 79.4,
    y1: 72.6,
    x2: 81.77,
    y2: 86.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 39.69,
    y1: 87.65,
    x2: 37.16,
    y2: 102.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 67.91,
    y1: 87.15,
    x2: 69.03,
    y2: 102.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 95.8,
    y1: 86.31,
    x2: 98.33,
    y2: 103.71
  }))), /*#__PURE__*/React.createElement("g", {
    id: "oeil_droit",
    "data-name": "oeil droit"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.06,63.42l0,.12a6.76,6.76,0,0,1-1.93,3.74,9,9,0,0,1-8.38,1.52,10.14,10.14,0,0,1-5.13-3.7c-4.82-7.26,4.2-15.36,11.47-12.2a7.57,7.57,0,0,1,3.86,3.53C55,58.58,54.62,61.1,54.06,63.42Z",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72,64.83a3.65,3.65,0,0,0,4.42-1,3.39,3.39,0,0,0,0-3.49,2.27,2.27,0,0,0-1.28-1.12,3,3,0,0,0-.9-.1,4.51,4.51,0,0,0-3.37,1,2.78,2.78,0,0,0-.7,2.06A3,3,0,0,0,45.72,64.83Z",
    transform: "translate(1.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "oeil_gauche",
    "data-name": "oeil gauche"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M79.55,52.7c-4.08-.62-9,1.72-10.12,5.86a9.1,9.1,0,0,0,1.24,7A5,5,0,0,0,71.86,67a5.38,5.38,0,0,0,1.63.8c2.74.89,5.82,1.21,8.49-.09a6.46,6.46,0,0,0,3.51-4,8.44,8.44,0,0,0,.23-1.94c.07-3.32-.43-6.58-3.65-8.25A8.64,8.64,0,0,0,79.55,52.7Z",
    transform: "translate(1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.15,61.33c0,1.11.32,2.72,1.38,3.27a3.66,3.66,0,0,0,2.86.25c3-1,3-5.82-.52-5.92a5.27,5.27,0,0,0-2.14.45,2.39,2.39,0,0,0-1.49,1.3A2,2,0,0,0,76.15,61.33Z",
    transform: "translate(1.75)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.b9152dc1a7ba948797d6cd60ecea00f8.svg";
export { ForwardRef as ReactComponent };